export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-tatty-teddy-909a43d7aa91a6829d094e97a77b206b.png";